import { call, put, takeLatest, } from 'redux-saga/effects';

import * as types from './types';
import { fetchInfo as actions, } from './actions';
import { repositories, } from 'api'

export {
    actions,
};

const info = new repositories.Info();

function* fetchInfo() {
    try {
        const { data, } = yield call([ info, 'get', ]);

        yield put(actions.success(data));
    } catch (error) {
        yield put(actions.failure(error.message));
    }
}

function* infoSaga() {
    yield takeLatest(types.FETCH_INFO_REQUEST, fetchInfo);
}

export default infoSaga;
